import config from './config.json'

let {
    geoserver,
    API_ENDPOINT,
} = config

const production = process.env.NODE_ENV == 'production'

const geoserverURL = production ? geoserver.PROD_URL : geoserver.DEV_URL
const geoserverWorkspace = geoserver.WORKSPACE
const apiEndpoint = production ? API_ENDPOINT.PROD : API_ENDPOINT.DEV

const configExport = Object.assign(config, {
    geoserver: { geoserverURL, geoserverWorkspace },
    apiEndpoint
})

export default configExport


// WEBPACK FOOTER //
// ./src/config/index.js